<template>
  <div class="video">
    <component :is="currentComponent"></component>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import YtPlayer from '@/components/ytPlayer/ytPlayer.vue'
  import IframeVideo from '@/components/iframeVideo/iframeVideo.vue'

  export default {
    components: {
      YtPlayer,
      IframeVideo
    },
    computed: {
      ...mapState('tours', ['video']),
      currentComponent () {
        return this.video.isYoutube
          ? 'ytPlayer'
          : 'iframeVideo'
      }
    }
  }
</script>
